import { HttpRequest } from "@services/HttpClient";
import { APIService } from "@custom-types/APIService";
import { APIServiceResponse } from "@custom-types/APIServiceResponse";
import { parseLabelToID } from "@utils/labelToId.utils";
import { getAPIUrl } from "@utils/service.utils";
import { trackErrorEvents } from "@utils/googleAnalytics/googleAnalyticsEvents";

type ResponseDataGS = {
  properties: Array<{ label: string; type: 'location'|'community' }>;
  total: number;
};
export type ParsedDataGS = Array<{
  value: string;
  label: string;
  type: string;
}>;

export function getSuggestionAPI(
  type: string = "p",
  destination?: string
): APIService<ParsedDataGS> {
  const destinationParam = destination ? `&text=${destination}` : '';
  const route = `search/property/suggestions?st=${type}${destinationParam}`;
  const httpRequest = new HttpRequest<APIServiceResponse<ResponseDataGS>>(
    getAPIUrl("search", route)
  );

  return {
    send: async () => {
      try {
        const response = await httpRequest.send();
        return parseSuggestionsResponse(response.data);
      } catch (err:any) {
        trackErrorEvents({
          type: 'get_suggestion_fetch_failed',
          errorStack: err,
        });
        throw err;
      }
    },
    abort: httpRequest.abort
  };
}

function parseSuggestionsResponse(data: ResponseDataGS): ParsedDataGS {
  const destinations = data.properties.filter(item => item.type === 'location');
  const communities = data.properties.filter(item => item.type === 'community');

  const sortedDestinations = destinations.sort((a, b) => a.label.localeCompare(b.label));
  const sortedCommunities = communities.sort((a, b) => a.label.localeCompare(b.label));

  return [ ...sortedDestinations, ...sortedCommunities].map(item => ({
    label: item.label,
    type: item.type,
    value: parseLabelToID(item.label),
  }));
}
